export default __webpack_public_path__ + "static/media/login.831cfeb8.jpg";